import styled from "styled-components/macro";

// Max width Container
export const maxWidthContainer = "688px";

export const MainWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  justify-items: end;
  transition: 0.5s;
  @media ${(props) => props.theme.media.leftmenu} {
    margin: 0 auto;
    width: 100%;
  }
`;

export const DivGrid = styled.div`
  display: grid;
  gap: 16px;
  margin-top: 24px;
  grid-template-areas:
    "minimumAge maximumAge"
    "preferredGender preferredLanguage";
  grid-template-columns: repeat(2, 1fr);
  align-items: start;
  #minimumAge {
    grid-area: minimumAge;
  }

  #maximumAge {
    grid-area: maximumAge;
  }

  #preferredGender {
    grid-area: preferredGender;
  }

  #preferredLanguage {
    grid-area: preferredLanguage;
  }

  @media ${(props) => props.theme.media.phone} {
    grid-template-areas:
      "minimumAge"
      "maximumAge"
      "preferredGender"
      "preferredLanguage";
    grid-template-columns: 1fr;
  }
`;
export const DivButtons = styled.div`
  width: 100%;
  max-width: ${maxWidthContainer};
  margin-bottom: 24px;
  text-align: right;
`;
